import type { AuthService } from "./service";
import type {
  IForgotPasswordRequest,
  ILoginRequest,
  ILoginResponse,
  IRefreshTokenRequest,
  IRefreshTokenResponse,
  IResetPasswordRequest,
  ISignupPasswordRequest,
  ISignupPasswordResponse,
  ISignupRequest,
  ISignupResponse,
} from "./types";
import { BaseRepository } from "../BaseRepository";
import type { IRepositoryOptions } from "@/types/common";

export interface IAuthRepository {
  login: (p: ILoginRequest) => Promise<ILoginResponse>;
  signup: (p: ISignupRequest) => Promise<ISignupResponse>;
  signupPassword: (
    p: ISignupPasswordRequest,
  ) => Promise<ISignupPasswordResponse>;
  forgotPassword: (p: IForgotPasswordRequest) => Promise<void>;
  resetPassword: (p: IResetPasswordRequest) => Promise<void>;
  refreshToken: (p: IRefreshTokenRequest) => Promise<IRefreshTokenResponse>;
}

export class AuthRepository extends BaseRepository implements IAuthRepository {
  constructor(
    private readonly service: AuthService,
    options?: IRepositoryOptions,
  ) {
    super(options);
  }

  async login(p: ILoginRequest): Promise<ILoginResponse> {
    const response = await this.handleRequest(this.service.login, p);
    return response.data;
  }

  async signup(p: ISignupRequest): Promise<ISignupResponse> {
    const response = await this.handleRequest(this.service.signup, p);
    return response.data;
  }

  async signupPassword(
    p: ISignupPasswordRequest,
  ): Promise<ISignupPasswordResponse> {
    const response = await this.handleRequest(this.service.signupPassword, p);
    return response.data;
  }

  async forgotPassword(p: IForgotPasswordRequest): Promise<void> {
    const response = await this.handleRequest(this.service.forgotPassword, p);
    return response.data;
  }

  async resetPassword(p: IResetPasswordRequest): Promise<void> {
    const response = await this.handleRequest(this.service.resetPassword, p);
    return response.data;
  }

  async refreshToken(p: IRefreshTokenRequest): Promise<IRefreshTokenResponse> {
    const response = await this.handleRequest(this.service.refreshToken, p);
    return response.data;
  }

  async logout(): Promise<void> {
    const response = await this.handleRequest(this.service.logout);
    return response.data;
  }
}
